import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const TbPClAgreementDecline = () => {
  const location = useLocation();
  const [formData, setFormData] = useState(null);
  useEffect(() => {
    // If the redirection results in POST data, extract and handle it
    const searchParams = new URLSearchParams(location.search);
    // Handle the POST data here (if it's passed as query params or through state)
    // // You might need to fetch additional data from your server here.

    setFormData(searchParams.get("data")); // Example: data passed as a URL parameter
  }, [location]);

  return (
    <div>
      <h1>PCL Decline Page</h1>
      <p>{formData}</p>
    </div>
  );
};
export default TbPClAgreementDecline;
